import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Spin, Table } from 'antd';
import { Link } from 'react-router-dom';
import IconButton from 'material-ui/IconButton';
import NewCustomerIcon from '@material-ui/icons/PersonAdd';

import AllEmployeesQuery from '../../graphql/queries/AllEmployeesQuery.graphql';

const { Column } = Table;

const Employees = (props) => {
  const { loading, employees } = props.data;
  const { url } = props.match;

  if (loading) {
    return (
      <Spin size="large" />
    );
  }
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <h2>Employees</h2>
        </div>
        <div className="col-auto ec-content-header-menu">
          <Link to={`${url}/create`}>
            <IconButton aria-label="Create new customer">
              <NewCustomerIcon />
            </IconButton>
          </Link>
        </div>
      </div>

      <div className="ec-content-box">
        <Table dataSource={employees} rowKey="id">
          <Column
            title="Name"
            dataIndex="name"
            key="name"
          />
          <Column
            title="Mobile"
            dataIndex="mobile"
            key="mobile"
          />
          <Column
            title="Email"
            dataIndex="email"
            key="email"
          />
          <Column
            title="Designation"
            dataIndex="designation"
            key="designation"
          />
          <Column
            title="Is Admin"
            key="isAdmin"
            render={(text, record) => (
              record.isAdmin ? 'Yes' : 'No'
            )}
          />
        </Table>
      </div>
    </div>
  );
};

Employees.propTypes = {
  data: PropTypes.shape({
    employees: PropTypes.array,
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default graphql(AllEmployeesQuery)(Employees);



// WEBPACK FOOTER //
// ./src/pages/employees/Employees.jsx